const WORKOUT_EXERCISES_DOMAIN = 'workoutExercises'

export default WORKOUT_EXERCISES_DOMAIN
